import { createExpansionStore, type ExpansionScope } from '@sl/core/tree';
import { browserDemoStorage } from '../app/api/ApiClientProvider';

// "Reset demo" and "Start fresh" forget which rows were open (REQ-910 AC3, D-097 (7)).
//
// The record lives at `sl.tree.expansion.<user>.<account>` — OUTSIDE the demo namespace, because the same
// record and the same adapter serve a live account, and "Start fresh" does not clear the demo namespace
// anyway. So the shell clears it by hand: one call, next to `client.resetDemo(...)`.

// **BUG-014** — clearing the RECORD is not clearing the TREE. `useTreeExpansion` reads the record once, on
// mount, and holds the answer in React state; a shell that wipes the record underneath it left the rows open
// on screen until the next reload, so "Reset demo" looked like it had not worked. The store has no way to
// reach a hook, and the hook has no way to know the shell did something, so this module is the seam: one
// module-level notification, sent after the record is gone, carrying the scope it was gone FOR. A mounted
// tree on that account re-reads and closes; a tree on another account is not touched.

type ClearedListener = (scope: ExpansionScope) => void;

const listeners = new Set<ClearedListener>();

/** Called by `useTreeExpansion`. Returns the unsubscribe, so an unmounted tree hears nothing. */
export function onExpansionCleared(listener: ClearedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export async function clearExpansionFor(scope: ExpansionScope): Promise<void> {
  await createExpansionStore(browserDemoStorage(), scope).clear();
  for (const listener of [...listeners]) listener(scope);
}
